/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

toCookie = function(item, forever = null) {
    days=30;
    if (forever !== null) {
        days = 3000;
    }
    myDate = new Date();
    myDate.setTime(myDate.getTime()+(days*24*60*60*1000));
    document.cookie = item + '=Accepted; expires=' + myDate.toGMTString();
};

getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

payStart = (element) => {
    const id = $(element).data('id');
    let data = {};
    data['id'] = id;
    $.ajax({
        url: '/videok/pay',
        type: 'POST',
        data: data,
        success: function (response) {
            console.log('response', response);
            $('#payModal .modal-footer').html(response.ret);
            $('#payModal').modal('show');
        },
        error: function (error) {
            if (error.status === 401) {
                $('.message').addClass('bg-danger').html("A fizetés megkezdéséhez bejelentkezés szükséges!");
            }
            else {
                $('.message').addClass('bg-danger').html(error.responseJSON.message);
            }
        }
    });
};

function scrollToAnchor(aid){
    var aTag = $("a[name='"+ aid +"']");
    $('html,body').animate({scrollTop: aTag.offset().top},'slow');
}

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(".sliding-link").click(function(e) {
        e.preventDefault();
        var aid = $(this).attr("href");
        $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
    });

    $('#cp_accept').on('click', function() {
        toCookie('TermsAndConditions');
        $("#cookie").hide();
    });

    $('#popupClose').on('click', function() {
        toCookie('PopupNotify');
        $("#popup-notify").hide();
    });

    $('#hideNewsletterForever').on('click', function () {
        toCookie('newsletter', true);
        $('#modalNewsletter').modal('hide');
    });

    $('#newsletterForm').on('submit', function (e) {
        e.preventDefault();

        let data = {};

        $(this).serializeArray().map((d) => {
            data[d.name] = d.value;
        });

        $('.message').removeClass('bg-danger').removeClass('bg-success').html("");

        $.ajax({
            url: 'newsletter',
            type: 'POST',
            data: data,
            success: function (response) {
                $('.message').addClass('bg-success').html(response.message);
                setTimeout(function () {
                    $('#modalNewsletter').modal('hide');
                }, 2000);
                toCookie('newsletter', true);
            },
            error: function (error) {
                $('.message').addClass('bg-danger').html(error.responseJSON.message);
            }
        });
    });

    $('#webinarForm').on('submit', function (e) {
        e.preventDefault();

        let data = {};

        $(this).serializeArray().map((d) => {
            data[d.name] = d.value;
        });

        $('.message').removeClass('bg-danger').removeClass('bg-success').html("");

        $.ajax({
            url: 'webinar',
            type: 'POST',
            data: data,
            success: function (response) {
                $('.message').addClass('bg-success').html(response.message);
                setTimeout(function () {
                }, 2000);
            },
            error: function (error) {
                $('.message').addClass('bg-danger').html(error.responseJSON.message);
            }
        });
    });

    if (getCookie('newsletter') !== 'Accepted') {
        $('#modalNewsletter').modal('show');
    }
});
